module.exports = __webpack_public_path__ + "static/media/mapNode2.a8b6f92a.png";